export const closableQueue = ref<string[]>([]);

export function useClosable(key: string) {
    const open = () => {
        if (closableQueue.value?.[0] === key) {
            return;
        }
        closableQueue.value.unshift(key);
    };

    const close = () => {
        if (closableQueue.value?.[0] === key) {
            closableQueue.value.shift();
        }
    };

    const isOpened = computed(() => closableQueue.value.includes(key));

    return { open, close, isOpened };
}

export const closeAll = () => {
    closableQueue.value = [];
};
